







































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import VerifiableAttribute from '@/components/Shared/VerifiableAttribute.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import AgencyRateCardPositionCreate from '@/components/RateCardPositions/AgencyRateCardPositionCreate.vue';
import AgencyRateCardPositionEdit from '@/components/RateCardPositions/AgencyRateCardPositionEdit.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import RateCardPositionDto from '@/models/RateCardPositions/RateCardPositionDto';

@Component({
  name: 'AgencyRateCardPositions',
  components: { VerifiableAttribute, AgencyRateCardPositionCreate, AgencyRateCardPositionEdit }
})
export default class extends GiganautVue {
    
    get positions() {
        return AgencySettingsModule.currentRateCard.positions;
    }

    async deleteRateCardPosition(rateCardPosition: RateCardPositionDto) {
        const options: VuetifyConfirmObject = {
                buttonTrueText: "DELETE",
                buttonFalseText: "CANCEL",
                buttonTrueColor: "primary",
                buttonFalseColor: "primary",
            }
        const result = await this.$confirm('Are you sure you want to delete this position?', options);
        if (result) {
            await AgencySettingsModule.deleteRateCardPosition(rateCardPosition);
        }
  }

}
